import { Component, OnInit } from '@angular/core';
import { AddingWithAttatchementsBaseComponent } from '../../../../shared/Components/adding-with-attatchements-base/adding-with-attatchements-base.component';
import { Portals } from '../../model/Portals';
import { Router } from '@angular/router';
import { NbDialogRef, NbToastrService } from '@nebular/theme';
import { PortalService } from '../../services/PortalService';
import { uploadService } from '../../../../shared/uploadService';
import { combineLatest, observable, Observable, of } from 'rxjs';
import { catchError, switchMap, tap } from 'rxjs/operators';
import { FileVm } from '../../../../shared/Models/fileVm';

@Component({
  selector: 'add-portals',
  templateUrl: './add-portals.component.html',
  styleUrls: ['./add-portals.component.scss'],
})
export class AddPortalsComponent extends AddingWithAttatchementsBaseComponent implements OnInit {
  model: Portals;
  isEdit = false;
  formData: FormData = new FormData();
  isLoading: boolean = false;
  newTag: string = '';
  newTagEN: string = '';
  uploadThumbnail = false;
  private validPhoto: boolean = true;
  private newPhotoUploaded = false;
  private imagePath: string;
  private imgURL: any;
  private file: any;
  private fileName: string;
  private Image: FileVm;
  constructor(
    private route: Router,
    public diagRef: NbDialogRef<AddPortalsComponent>,
    public service: PortalService,
    public toast: NbToastrService,
    private uploadservice: uploadService
  ) {
    super(service, null);
  }

  ngOnInit() {
    this.route.events.subscribe(() => {
      this.diagRef.close('false');
    });
    if (this.isEdit) {
      this.uploadservice.updateFiles({ files: [], previousAttachments: this.model.attachments });
    }
    if (!this.isEdit) {
      this.model = {} as Portals;
      this.model.descriptionAR = '';
      this.model.descriptionEN = '';
      this.uploadThumbnail = true;
      this.uploadservice.updateFiles({ files: [], previousAttachments: [] });
    }
  }

  close() {
    this.diagRef.close();
  }

  isAttachementsValid(): boolean {
    if (!this.uploadservice.isFilesEmpty() || !this.uploadservice.isPrevAttachementsEmpty()) return true;

    return true;
  }

  removePhoot() {
    this.uploadThumbnail = true;
    this.validPhoto = false;
  }

  addTags() {
    if (this.newTag) {
      if (!this.model.tags) this.model.tags = [];
      this.model.tags.push(this.newTag);
      this.newTag = '';
    }
  }

  removeTag(item) {
    this.model.tags = this.model.tags.filter((x) => x !== item);
  }

  addTagEN() {
    if (this.newTagEN) {
      if (!this.model.tagsEN) this.model.tagsEN = [];
      this.model.tagsEN.push(this.newTagEN);
      this.newTagEN = '';
    }
  }

  removeTagEN(item) {
    this.model.tagsEN = this.model.tagsEN.filter((x) => x !== item);
  }

  save(form) {
    this.isLoading = true;
    const attachments$ = this.uploadservice.uploadMultipleFiles();
    const attachment$ = this.uploadservice.uploadImage(this.formData);
    combineLatest([attachments$, attachment$])
      .pipe(
        catchError(() => {
          console.log('error here in combine latest ');
          this.isLoading = false;
          return of(null);
        }),

        switchMap(([attachments, img]) => {
          // Update the model with the uploaded image and attachments
          // this.model.attachements = {
          //   fileName: img.fileName,
          //   originalFileName: img.originalFileName,
          // } as FileVm;

          this.model.attachments = attachments;
          this.model.iconLink = img.fileName;

          // for(let i of  this.model.attachments)
          // {

          //    let fileType= this.uploadservice.chooseFileType(i.fileName)
          //    i.type = fileType;
          //    console.log("file name ="+""+i.fileName +""+"file type ="+""+i.type)
          // }

          // .res.map((ele:FileVm) => { return {
          //   originalFileName:ele ,
          //   fileName :ele
          // }});

          // Return the observable that saves the entity
          // return this.saveEntity(this.model);

          return this.saveEntity(this.model);
        }),
        tap(([img, attachments]) => {})
      )
      .subscribe(
        (res) => {
          this.isLoading = false;

          this.diagRef.close('true');
          this.toast.show('تم إضافة مراكز', '', { status: 'success', duration: 3000 });
        },
        () => {
          this.isLoading = false;

          this.diagRef.close('true');
        }
      );
  }

  getFormData(event) {
    this.formData = event;
    if (event) this.validPhoto = true;
  }

  saveEntity(model): Observable<any> {
    return this.service.post(model);
  }

  update() {
    this.isLoading = true;

    const attachments$ = this.uploadservice.uploadMultipleFiles();

    // Check if formData is empty using forEach
    let isFormDataEmpty = true;
    this.formData.forEach(() => {
      isFormDataEmpty = false;
    });
    const attachment$ = !isFormDataEmpty ? this.uploadservice.uploadImage(this.formData) : of(null);

    combineLatest([attachments$, attachment$])
      .pipe(
        switchMap(([attachments, img]) => {
          this.model.attachments = attachments;
          if (img && img.fileName) {
            this.model.iconLink = img && img.fileName ? img.fileName : undefined;
          }
          return this.service.put(this.model.id, this.model);
        })
      )
      .subscribe({
        next: (res) => {
          this.isLoading = false;
          this.diagRef.close('true');
          this.toast.show('تم تعديل المركز بنجاح', '', { status: 'success', duration: 3000 });
        },
        error: (err) => {
          this.diagRef.close('true');
          this.toast.danger('خطأ في تعديل المركز ', 'خطأ', { status: 'success', duration: 3000 });
        },
      });
  }
}
